export function BentoCard({
  imgSrc,
  headline,
  description,
}: {
  imgSrc: string
  headline: string
  description: string
}) {
  return (
    <div className='relative p-1'>
      <div className='absolute inset-0 bg-gradient-to-b from-neutral-10 to-transparent rounded-2xl'>
        <div className='absolute inset-px bg-gray-50 rounded-2xl' />
      </div>
      <div className='relative bg-white rounded-12 overflow-hidden border border-neutral-10'>
        <img src={imgSrc} className='w-full' />
        <div className='p-5 space-y-2'>
          <h3 className='text-18 leading-tight font-demibold text-neutral-110'>
            {headline}
          </h3>
          <p className='text-15 font-medium leading-snug'>{description}</p>
        </div>
      </div>
    </div>
  )
}
